<template>
	<div>
		<el-select v-model="busyValue" placeholder="请选择" size="small" style="width: 100%">
			<el-option v-for="item in StoreAuxList" :key="item.auxCode" :label="item.auxDesc" :value="item.auxCode"></el-option>
		</el-select>
		<div style="text-align: center;margin-top: 18px;">
			<el-button @click="handleBusyOperate" :loading="loading" size="mini" type="primary">确认</el-button>
			<el-button @click="$emit('signClose')" size="mini">取消</el-button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	props: ['manageAux'],
	computed: {
		...mapGetters([
			'userInfo',
			'StoreIsBusy',
			'StoreIsBusyReason',
			'StoreAuxList'
		])
	},
	data() {
		return {
			loading: false,
			auxObj: {},
			busyValue: '',
		}
	},
	watch: {
		StoreAuxList: {
			handler(val) {
				this.busyValue = '';
				for(const item of val) {
					this.auxObj[item.auxCode] = item.auxDesc;
				}
			},
			immediate:true
		}
	},
	methods: {
		...mapMutations({
			'SET_SOFT_PHONE_IN_MSG': 'telService/SET_SOFT_PHONE_IN_MSG',
			'SET_IS_IDLE': 'telService/SET_IS_IDLE',
			'SET_IS_BUSY': 'telService/SET_IS_BUSY',
			'SET_IS_CALL': 'telService/SET_IS_CALL',
			'SET_IS_ANSWER': 'telService/SET_IS_ANSWER',
			'SET_IS_KEEP': 'telService/SET_IS_KEEP',
		}),
		handleBusyOperate() {
			if(!this.busyValue){
				this.$message.error({message: `请选择置忙原因`, offset: 70});
				return;
			}
			this.loading = true;
			this.$api.apiPostCallSetBusy({agentName: this.userInfo?.agentCode, auxCode: this.busyValue}).then(response => {
				if(response.errcode != 0) {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '置忙失败',
						data: {
							errmsg: response?.errmsg
						}
					});
					this.loading = false;
					return;
				};
				this.SET_IS_BUSY({
					StoreIsBusy: true, 
					StoreIsBusyReason: this.auxObj[this.busyValue]
				});
				this.SET_IS_KEEP(false);
				this.SET_IS_IDLE(false);
				this.SET_IS_CALL(false);
				this.SET_IS_ANSWER(false);
				this.$emit('signClose');
				this.loading = false;
				this.$message.success({message: `置忙成功`, offset: 70});
				this.SET_SOFT_PHONE_IN_MSG({
					msg: '置忙成功, 置忙原因',
					data: {
						busyValue: this.busyValue
					}
				});
			});
		},
	}
}
</script>